import { useState } from "react";
import "./ShareProfile.css";
import { CiGlobe } from "react-icons/ci";
import { MdContentCopy, MdOpenInNew } from "react-icons/md";
import { toast } from "react-toastify";
import { useAuth } from "../../../../Providers/Auth";
import { VscGlobe } from "react-icons/vsc";
import { Button } from "@/shadcnComponents/ui/button";
import { IoMdCheckmarkCircleOutline, IoMdOpen } from "react-icons/io";
import MobileMenuBar from "@/Components/Menubar/MobileMenuBar";

export const ShareProfileSection1 = ({ setCurrentSection }) => {
  const authState = useAuth();

  return (
    <>
      <div className="w-full font-inter px-[16px] md:px-10 py-5 pb-[100px] md:pb-5 box-border flex items-center justify-between h-max ">
        <section className="flex flex-col gap-[30px] w-full">
          <div className=" flex flex-col gap-[12px] items-start ">
            <span className="text-[16px] md:text-[24px] font-[600] text-[#FFFFFF]  ">
              Almost there!
            </span>
            <span className=" text-neutral-400 text-xs md:text-base not-italic font-normal leading-[normal]">
              These creative ways will help you stand out and make it easy for
              brands to find you
            </span>
          </div>

          <div className="flex flex-col gap-[30px]  py-5 w-[100%] md:w-[80%] rounded-[6px] item-center justify-between border-[1px] border-[solid] border-[#262626] bg-[rgba(255,_255,_255,_0.02)]">
            <div className="flex item-center justify-between">
              <div className="w-1/2 p-4 flex flex-col justify-center ">
                <div className="flex flex-col gap-[4px]">
                  <div className="text-white text-xs md:text-sm not-italic font-semibold leading-[normal]">
                    Showcase On Your Socials
                  </div>
                  <div className="text-[#A6A6A6] text-[10px] md:text-[12px] leading-[20px]">
                    Creators who have this link in their bio have better brand
                    visibility and more likely to land a collab
                  </div>
                </div>
                <div className="w-fit flex justify-center items-center rounded-[100px] border-[1px] border-[solid] border-[#A3A3A3] mt-5 mb-3">
                  <div className="flex px-[8px] py-[6px] justify-start items-center gap-[15px]">
                    <VscGlobe size={18} color="#757575" />
                    <span className="text-[#A3A3A3] text-[12px] font-normal leading-[20px]">
                      {window.location.host}/{authState?.loggedUser?.slug}
                    </span>
                  </div>
                  <button
                    className="hover:bg-[#232323] hover:rounded-full px-[8px] py-[6px]"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigator.clipboard.writeText(
                        `${window.location.protocol}//${window.location.host}/${authState?.loggedUser?.slug}?utm_source=profile`
                      );

                      toast.info("Profile Link Copied", {
                        position: "top-center",
                        autoClose: 1000,
                      });
                    }}
                  >
                    <MdContentCopy size={18} color="#757575" />
                  </button>
                </div>
                <div className="flex mt-[8px] gap-2">
                  {/* <LinkButton
                    onClick={() => {
                      navigator.clipboard.writeText(
                        `${window.location.protocol}//${window.location.host}/${authState?.loggedUser?.slug}?utm_source=profile`
                      );
                      window.open(
                        "https://www.linkedin.com/in/me/edit/forms/custom-action/new/",
                        "_blank"
                      );
                    }}
                    className="pl-0"
                  >
                    <CiLinkedin size={18} />
                    Add in Bio
                    <MdOpenInNew size={14} />
                  </LinkButton> */}
                  <Button
                    className="items-center gap-[10px] "
                    variant="destructive"
                    onClick={() => {
                      navigator.clipboard.writeText(
                        `${window.location.protocol}//${window.location.host}/${authState?.loggedUser?.slug}?utm_source=profile`
                      );
                      window.open(
                        "https://www.linkedin.com/in/me/edit/forms/custom-action/new/",
                        "_blank"
                      );
                    }}
                  >
                    Add link to linkedIn bio <MdOpenInNew size={14} />
                  </Button>
                </div>
              </div>
              <div className="w-1/2 hidden md:flex items-start md:items-center justify-center p-4 ">
                <div className="flex gap-4">
                  <img
                    src={
                      "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/BoostVisibilityNew1.png"
                    }
                    alt=""
                    className="w-[260px] h-[150px] md:h-[342px] flex-shrink-0 rounded-[10px]"
                  />
                </div>
              </div>
            </div>
            <div
              onClick={() => setCurrentSection("second")}
              className="cursor-pointer  w-[95%] flex justify-end text-[#A6A6A6] text-xs not-italic font-normal leading-5 tracking-[0.12px] "
            >
              I’ll do it later
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export const ShareProfile = () => {
  const authState = useAuth();
  const [currentSection, setCurrentSection] = useState("first");

  const handleCopy = () => {
    const textToCopy = `collab.anchors.in/${authState?.loggedUser?.slug}`;
    navigator.clipboard.writeText(textToCopy);
    toast.success("Your profile Link Copied", {
      autoClose: 1000,
    });
  };
  return (
    <>
      <MobileMenuBar />
      {currentSection === "first" && (
        <ShareProfileSection1 setCurrentSection={setCurrentSection} />
      )}
      {currentSection === "second" && (
        <div className="flex w-full md:h-full px-[20px] py-[16px] pb-[80px]  items-center justify-center ">
          <div className="w-full flex flex-col md:flex-row items-center justify-around m-y-auto m-x-0 ">
            <div className=" flex font-inter flex-col justify-center items-center gap-[20px] ">
              <div className="left_successfull_tick_container">
                {/* <img
                  src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/successTick.png"
                  className="animate-pulse"
                  alt=""
                  style={{
                    width: "100px",
                    height: "100px",
                  }}
                /> */}
                <IoMdCheckmarkCircleOutline size={40} color="green" />
              </div>
              <div className="flex flex-col  gap-1 ">
                <span className="text-white text-center text-sm not-italic font-semibold leading-[normal]">
                  Congratulations! <br />
                  Your Profile Is All Set
                </span>
                <span className="w-[329px] text-[#A6A6A6] text-center text-xs not-italic font-normal leading-5 tracking-[0.12px]">
                  Creators who have this link in their bio have better brand
                  visibility and more likely to land a collab
                </span>
              </div>
              <div className="flex gap-[15px] px-3 py-2 justify-between items-center rounded-full border border-[#757575] text-neutral-400 text-center text-xs not-italic font-normal leading-5 ">
                <CiGlobe size={18} />
                <h3>collab.anchors.in/{authState?.loggedUser?.slug}</h3>
                <div onClick={handleCopy} style={{ cursor: "pointer" }}>
                  <MdContentCopy size={18} />
                </div>
              </div>
              <Button
                onClick={() =>
                  window.open(
                    `https://collab.anchors.in/${authState?.loggedUser?.slug}`,
                    "_blank"
                  )
                }
                className="gap-2 items-center"
                variant="destructive"
              >
                Check your public Profile <IoMdOpen />
              </Button>
            </div>
            <div className="flex influencer_right_shareprofile_container">
              {/* <div  className="w-[360px] h-[400px] overflow-auto ">
                <div className="w-full  ">
                  <InfluencerPublicProfile />
                </div>
              </div> */}
              <div className="flex flex-col gap-[8px]  scale-[0.8]  rounded-lg overflow-hidden ">
                <iframe
                  className="rounded-lg bg-transaprent "
                  title="Profile Component"
                  src={`/${authState?.loggedUser?.slug}`}
                  width="360"
                  height="600"
                  frameBorder="0"
                  onLoad={(e) => {
                    const iframeDocument = e.target.contentDocument;
                    if (iframeDocument) {
                      const iframeStyles =
                        iframeDocument.createElement("style");
                      iframeStyles.textContent = `
                        body {
                          overflow: hidden !important;
                          scrollbarWidth: none;
                          border: none;
                          background:transparent
                        }
                      `;
                      iframeDocument.body.appendChild(iframeStyles);
                    }
                  }}
                />
                <span className="text-[#A6A6A6] font-inter text-center text-xs not-italic font-normal leading-5 tracking-[0.12px]">
                  Public Profile View
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
